import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoIosArrowForward } from 'react-icons/io';
import NavbarText from '../components/NavbarText';
import { TmTBMDngrEval } from '../components/teamTBM/TmTBMDngrEval';
import TmTBMChkList from '../components/teamTBM/TmTBMChkList';
import Select from '../components/ui/Select';
import { Agrd, TBMFldAgnt, TBMMainDtl } from '../interface/Interface';
import * as securityHelper from "../helper/SecurityHelper";
import * as fn from '../api/FnSmartTBM';
import Snackbar from '../components/Snackbar';
import Camera from '../components/modal/Camera';
import axios from "axios";

export default function TeamTBM() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = securityHelper.getLoginUser();
  const doneTBM = location.state.doneTBM;
  const wrkInfo = location.state.wrkInfo;
  const wrkDclrSeq = location.state.wrkDclrSeq;
  const wrkDclrList = location.state.wrkDclrList;
  const [tab, setTab] = useState(1);
  const agrdInit = { 1: false, 2: false }
  const [agrd, setAgrd] = useState<Agrd>(agrdInit);
  const [selectPopup, setSelectPopup] = useState(false);
  const [selectData, setSelectData] = useState<string[]>([]);
  const [select, setSelect] = useState('');
  const [focus, setFocus] = useState(false);
  const dngrEvalRef = useRef<HTMLDivElement>();
  const [wrkDclrNoList, setWrkDclrNoList] = useState([]);
  const [readWrkDclrList, setReadWrkDclrList] = useState([]);
  const [mainDtlData, setMainDtlData] = useState<TBMMainDtl>();
  const [fldAgntDataList, setFldAgntDataList] = useState<TBMFldAgnt[]>([]);
  const [dngrEvalDataList, setDngrEvalDataList] = useState<any>([]);
  const [wrkrInfoDataList, setWrkrInfoDataList] = useState([]);
  const fileRef = useRef() as React.MutableRefObject<any>;
  const [fileSrc, setFileSrc] = useState('');
  const [camOpen, setCamOpen] = useState(false);
  const [snackbarTxt, setSnackbarTxt] = useState('');
  const [apprMemo, setApprMemo] = useState('');

  useEffect(() => { setTimeout(() => setSnackbarTxt(''), 2000) }, [snackbarTxt]);
  useEffect(() => { if (doneTBM) { fn_retrieveTmTbmImg(); } }, []);
  const fn_retrieveTmTbmImg = async () => {
    const wrkDclrSeqStr = wrkDclrSeq.toString();
    let tmTbmImg = await axios.post('admin/api/dngrEval/retrieveTmTbmImg', {wrkDclrSeqStr: wrkDclrSeqStr, userSeq: user.seq, isMobile: 'Y'})
    let imgFile = tmTbmImg.data.fileList[0]
    let imgSrc = '';
    if (imgFile.base64str) {
      let imgSrc = 'data:image/;base64,' + imgFile.base64str;
    }
    setFileSrc(imgSrc);
  }
  const fn_retrieveImgFile = async (atchFileId: any) => {
    let fileInfo = await axios.post('admin/cmmn/fileInfoForTableView', {atchFileId:atchFileId});
    return fileInfo.data
  }
  const backEvent = () => {
    if (tab === 1) { navigate(-1); }
    else {
      // setAgrd((prevState) => ({ ...prevState }));
      setTab((prevState) => prevState - 1);
    }
  };
  const nextBtnMsg = !doneTBM ? tab === 1 ? '모든 위험요인을 공지하고\n작업자 명단을 확인했습니다.' : '작업자 전원의 보호장비 착용을 확인했습니다.' : '확 인'
  const nextHandler = async () => {
    if (tab === 1) {
      if (!doneTBM) {
        if (!fn.tabOneMoveNext({ readWrkDclrList, wrkDclrList, dngrEvalRef, setFocus, setSnackbarTxt })) { return; }
        // if (agrd[tab] === false) { return setSnackbarTxt('숙지 여부에 체크해 주십시오.'); }
      }
      setTab(tab + 1);
    }
    if (tab === 2) {
      if (!doneTBM) {
        if (fileSrc === '') { return setSnackbarTxt('보호구 착용사진을 첨부해주세요.'); }
        // if (agrd[tab] === false) { return setSnackbarTxt('숙지 여부에 체크해 주십시오.'); }
        let evntSeqArr = new Set();
        let sctrGbArr = new Set();
        wrkDclrList.map((wrkDclrData: any) => {
          evntSeqArr.add(wrkDclrData.evntSeq);
          sctrGbArr.add(wrkDclrData.sctrGb);
        });
        let evntSeqStr = [...evntSeqArr].join();
        let sctrGb = [...sctrGbArr].join();
        let rsltCnt = 0;
        rsltCnt = await fn.saveTmTbmData(fileRef, user, evntSeqStr, sctrGb, wrkDclrSeq);
        if (rsltCnt > 0) {
          navigate('/main');
        }
      } else {
        navigate('/main');
      }
    }
  };
  const selectHandler = async (data: any) => {
    setSelect(data.wrkInfo);
    setSelectPopup(false);
    // @ts-ignore
    const newList = readWrkDclrList.concat(Number(data.wrkDclrSeq));
    setReadWrkDclrList(newList);
    let paramWrkDclrSeq = data.wrkDclrSeq;
    fn.retrieveDngrEvalDtl({ wrkDclrSeq: paramWrkDclrSeq, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setDngrEvalDataList, setApprMemo });
  };

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      {camOpen && <div className='absolute z-[999]'><Camera user={user.name} setCamOpen={setCamOpen} fileRef={fileRef} imgSrc={fileSrc} setImgSrc={setFileSrc} /></div>}
      <NavbarText backEvent={backEvent}>팀 안전교육</NavbarText>
      <Tab tab={tab} />
      {tab === 1 && <div className='w-full flex justify-center items-center -mt-35 mb-15 md:-mt-[87px] md:mb-[37px]'><Select selectHandler={selectHandler} select={select} selectPopup={selectPopup} setSelectPopup={setSelectPopup} selectData={selectData} focus={focus} seq >평가서</Select></div>}
      <div id={"team-tbm-area"} className={tab === 1 ? 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-157px)] md:h-[calc(100%-392px)]'
        : 'bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-107px)] md:h-[calc(100%-267px)]'}>
        <div className='mb-20 md:mb-[50px]'>
          {tab === 1 &&
            <TmTBMDngrEval ref={dngrEvalRef} user={user} mainDtlData={mainDtlData} fldAgntDataList={fldAgntDataList} dngrEvalDataList={dngrEvalDataList} setDngrEvalDataList={setDngrEvalDataList} wrkrInfoDataList={wrkrInfoDataList} wrkDclrList={wrkDclrList} wrkDclrSeq={wrkDclrSeq} apprMemo={apprMemo}
              wrkInfo={wrkInfo} setWrkDclrNoList={setWrkDclrNoList} setReadWrkDclrList={setReadWrkDclrList} wrkDclrNoList={wrkDclrNoList} setFldAgntDataList={setFldAgntDataList} setWrkrInfoDataList={setWrkrInfoDataList} setMainDtlData={setMainDtlData} setSelect={setSelect} setSelectData={setSelectData} setApprMemo={setApprMemo} />}
          {tab === 2 &&
            <TmTBMChkList fileRef={fileRef} camOpen={camOpen} setCamOpen={setCamOpen} fileSrc={fileSrc} doneTBM={doneTBM} />}
        </div>
        <button onClick={nextHandler} className='text-15 md:text-37 text-white w-[265px] sm:w-[318px] md:w-[750px] py-7 outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px] mt-auto mb-20 md:mb-[50px] whitespace-pre-line'>
          {nextBtnMsg}
        </button>
      </div>
    </div>
  );
}

const Tab = ({ tab }: any) => {
  return (
    <div className={tab === 1 ? 'w-full h-82 md:h-[205px] flex flex-col justify-center px-17 md:px-[42px] bg-back text-13 sm:text-15 md:text-37 leading-18 md:leading-[45px]'
      : 'w-full h-55 md:h-[137px] flex flex-col justify-center px-17 md:px-[42px] bg-back text-13 sm:text-15 md:text-37 leading-18 md:leading-[45px]'}>
      <div className={tab === 1 ? 'flex items-center justify-evenly mb-45 md:mb-[112px]' : 'flex items-center justify-evenly'}>
        <p className={tab === 1 ? 'text-point font-preLight' : 'font-preLight'}>➀ 위험성평가서</p>
        <IoIosArrowForward className={tab === 1 ? 'text-point' : ''} />
        <p className={tab === 2 ? 'text-point font-preLight' : 'font-preLight'}>➁ 안전보호구 착용 확인</p>
      </div>
    </div>
  );
};